import html2canvas from "html2canvas";

const MAX_DISCLAIMER_HEIGHT = 670;
const MAX_DISCLAIMER_WIDTH = 565;
const ESTIMATED_CHARACTER_WIDTH = 5;

/**
 * Captures a rendered SOR template disclaimer as an image, since @react-pdf can't render HTML.
 * The element is kept `visibility: hidden`, so only html2canvas's clone is made visible to capture it.
 * Width is estimated from the text length, as the programme SOR does, so both PDFs lay it out alike.
 * @param {HTMLElement} disclaimerElement The rendered disclaimer (read through a ref).
 * @returns {Promise<object>} LetterHeadPDF3's noteImage/divOrgHeight/divWidth props.
 */
export async function renderSorDisclaimerImage(disclaimerElement) {
    try {
        const canvas = await html2canvas(disclaimerElement, {
            onclone: (clonedDocument, clonedElement) => {
                clonedElement.style.visibility = "visible";
            },
        });

        return {
            noteImage: canvas.toDataURL(),
            divOrgHeight: Math.min(disclaimerElement.clientHeight, MAX_DISCLAIMER_HEIGHT),
            divWidth: Math.min(disclaimerElement.textContent.trim().length * ESTIMATED_CHARACTER_WIDTH, MAX_DISCLAIMER_WIDTH),
        };
    } catch (error) {
        console.log("SorDisclaimerImage.js->renderSorDisclaimerImage->Error", error);
        throw error;
    }
}
